export interface DetallePedido {
  detalleId: number;
  pedidoId: number;
  productoId: number | null;
  nombreProducto: string;
  precioUnitario: number;
  cantidad: number;
  subtotal: number;
  imagenUrl: string | null;
}

export interface CreateDetallePedidoDto {
  pedidoId: number;
  productoId?: number | null;
  nombreProducto: string;
  precioUnitario: number;
  cantidad: number;
  imagenUrl?: string | null;
}

class DetallePedidosService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;
    const response = await fetch(url, {
      ...options,
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Error en la conexión con el servidor',
      }));
      throw new Error(errorData.message || `Error HTTP: ${response.status}`);
    }

    if (response.status === 204) {
      return {} as T;
    }

    return response.json();
  }

  async getByPedido(pedidoId: number): Promise<DetallePedido[]> {
    return this.request<DetallePedido[]>(`/detallepedidos/pedido/${pedidoId}`);
  }

  async getById(id: number): Promise<DetallePedido> {
    return this.request<DetallePedido>(`/detallepedidos/${id}`);
  }

  async create(data: CreateDetallePedidoDto): Promise<DetallePedido> {
    return this.request<DetallePedido>('/detallepedidos', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}

export const detallePedidosService = new DetallePedidosService();
